<button [class]="buttonClass" (click)="setValue(!value)" [disabled]="disabled">
    <i class="icon-sort-by-attributes" *ngIf="!value" title="Ascending order"></i>
    <i class="icon-sort-by-attributes-alt" *ngIf="value" title="Descending order"></i>
</button>
